<template lang="pug">
  v-card.py-3(flat)
    v-row.px-2(no-gutters)
      v-text-field(
        v-model='form.code'
        dense
        outlined
        width='80%'
        hide-details='auto'
        :label="$t('label.voucher-code')"
      )
      v-btn.ml-2(
        height='40'
        depressed
        :loading='loading'
        @click='submit'
      ) {{ $t('button.add') }}
    dialog-add-voucher-success(ref='rDialogSuccess')
    dialog-promotion-lock(ref='dialogPromotionLockRef')

</template>
<script>
import dialogAddVoucherSuccess from './DialogAddVoucherSuccess'
import { vouchers as apiVoucher } from '@/apis'
import DialogPromotionLock from '@/components/Promotion/DialogPromotionLock'

const DEFAULT = () => ({ 
    form : {},
    loading : false 
})
export default { 
  components:{
    dialogAddVoucherSuccess,
    DialogPromotionLock
  },
  data: () => DEFAULT(),   
  computed:{ 
    code () {
      return this.$route.query.code
    }
  },
  async mounted () {
    if(this.code){ 
      this.form = {
        code:this.code
      }
      this.submit() 
    }
  },
  methods : {  
    async submit () { 
      this.loading = true
      const [err,data,,,status ] = await apiVoucher.redeem(this.form)
      this.loading = false

      if (status == 423) {
        this.$refs.dialogPromotionLockRef.open()
        return
      }

      if(err) { 
        this.$alert('',err,'warning')  
        return
      }

      data.image = data.image_url
      this.$refs.rDialogSuccess.open(data)
      // this.$alert('',messages,'success')  
      this.$emit('success')
    }, 
  }
}
</script>